module.exports = __webpack_public_path__ + "img/share_modle_jian20@2x.1a39e29a.png";